import { DynamicStandaloneFactbox } from '@/components/Factbox';
import { LabradorComponent } from '@/types/component';
import cn from '@/utils/cn';
import { withBackgroundColor } from '@/utils/withBackgroundColor';
import withDebugMetadata from '@/utils/withDebugMetadata';
import { renderContentComponent } from 'modules/dynamic/components';

export const AllasLabradorFactbox: LabradorComponent = ({ type, meta, data, descendants }) => {
  const images = descendants.map(renderContentComponent);

  const backgroundColor = withBackgroundColor(meta.backgroundColor) ?? 'bg-al-korall-100';

  return (
    <DynamicStandaloneFactbox
      headline={data.title}
      bodyText={data.bodytext}
      images={images}
      data-content-index={meta.contentIndex}
      options={{ className: cn(backgroundColor) }}
      {...withDebugMetadata({ type, meta })}
    />
  );
};

export default AllasLabradorFactbox;
